/** Normalize an ISO or date string to YYYY-MM-DD for date inputs and API. */
export function toDateOnly(s: string | null | undefined): string {
  if (s == null || s === '') return '';
  const part = s.slice(0, 10);
  if (part.length === 10 && part[4] === '-' && part[7] === '-') return part;
  try {
    return new Date(s).toISOString().slice(0, 10);
  } catch {
    return '';
  }
}

/** Format a date string as DD/MM/YYYY for display. */
export function formatDateDDMMYYYY(s: string | null | undefined): string {
  const ymd = toDateOnly(s);
  if (!ymd) return '';
  const [y, m, d] = ymd.split('-');
  return `${d}/${m}/${y}`;
}

/** Format an instant as a short relative time string (e.g. "just now", "5m ago", "2h ago", "3d ago").
 *  Falls back to DD/MM/YYYY for anything older than a week. */
export function formatRelativeTime(input: string | Date | null | undefined): string {
  if (input == null || input === '') return '';
  const then = input instanceof Date ? input.getTime() : new Date(input).getTime();
  if (Number.isNaN(then)) return '';
  const diffSec = Math.floor((Date.now() - then) / 1000);
  if (diffSec < 60) return 'just now';
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return `${diffHr}h ago`;
  const diffDay = Math.floor(diffHr / 24);
  if (diffDay < 7) return `${diffDay}d ago`;
  return formatDateDDMMYYYY(input instanceof Date ? input.toISOString() : input);
}
